import { useQuery } from '@tanstack/react-query';
import { useAuth } from '../../contexts/authContext';
import { projectDataClient } from '../../lib/connect/clients';
/**
 * The proposal record header (GetProposalRecordHeader, PRP-01): name, pursuit
 * link, nav counts and the caller's edit/pricing gates in one call. Keyed by
 * tenant:user because counts and gates are caller-scoped.
 */ export function useProposalRecordHeader(projectId) {
    const { user } = useAuth();
    return useQuery({
        queryKey: [
            'proposal-record-header',
            `${user?.tenant_id}:${user?.id}`,
            projectId
        ],
        enabled: Boolean(projectId),
        staleTime: 30000,
        queryFn: ()=>projectDataClient.getProposalRecordHeader({
                projectId
            })
    });
}
